var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "inp-subtle inp-type fragment-type",
    class: {
      'inp-type-active': _vm.options
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.submit($event)
      },
      "keydown": _vm.keydown
    }
  }, [_c('span', {
    staticClass: "inp-subtle-span",
    domProps: {
      "textContent": _vm._s(_vm.term || _vm.text)
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.term),
      expression: "term"
    }],
    attrs: {
      "type": "text",
      "placeholder": _vm.text
    },
    domProps: {
      "value": (_vm.term)
    },
    on: {
      "blur": _vm.blur,
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.term = $event.target.value
      }, _vm.input],
      "focus": _vm.input
    }
  }), _vm._v(" "), (_vm.options) ? _c('div', {
    staticClass: "ref-select"
  }, [_c('div', {
    staticClass: "ref-scroll"
  }, _vm._l((_vm.options), function(opt, index) {
    return _c('div', {
      key: opt.item,
      staticClass: "ref-option",
      class: {
        'ref-ghost': index === _vm.ghost
      },
      domProps: {
        "textContent": _vm._s(opt.item + ' ' + opt.score)
      },
      on: {
        "mouseenter": function($event) {
          _vm.ghost = index
        },
        "mousedown": function($event) {
          _vm.confirm(opt.item)
        }
      }
    })
  }))]) : _vm._e()])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d29cbcd","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/InputClass.vue
// module id = 50
// module chunks = 1